#import "../fragments/activity-for-modal-fragment.graphql"

mutation ActivityRecordingDelete($input: ActivityRecordingDeleteInput!) {
    activityRecordingDelete(input: $input) {
        activity {
            ...ActivityModalFragment
        }
    }
}
